import React from 'react';
import penroseLogo from '../assets/penrose logo.jpeg';

const Header = () => {
  return (
    <header 
      className="sticky-top border-bottom" 
      style={{ 
        borderColor: '#27272a',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(10px)',
        zIndex: 10
      }}
    >
      <div className="container py-3">
        <div className="d-flex align-items-center gap-3">
          <img 
            src={penroseLogo} 
            alt="SPG LLM" 
            className="rounded" 
            style={{ 
              height: '32px', 
              width: '32px', 
              objectFit: 'cover',
              border: '1px solid rgba(250, 92, 54, 0.6)'
            }} 
          />
          <div>
            <h1 className="h4 mb-0 fw-bold text-white">SPG LLM</h1>
            <p className="small mb-0" style={{
              color: '#ffffff'
            }}>
              Powered by Penrose
            </p>
          </div>
        </div>
      </div>
      <div className="glow-divider" />
    </header>
  );
};

export default Header;
